import React from 'react';
import {Button} from 'antd';
import styles from "./layout.module.less";
import checkPic from "inc/check.png"
import history from "libs/history";

import store from "./store";
import {observer} from 'mobx-react';

// the hook
import { useTranslation } from 'react-i18next';

export default observer(function () {
  const {t, i18n} = useTranslation()
  return (
    <React.Fragment>
      <div className={styles.cart}>

        <div className={styles.listTitle}>
          <div className={['steps', styles.steps].join(" ")} data-class={'prev, cur'}>
            <div className="step">{t('我的报价单')}</div>
            <div className="step prev">{t('填写并核对订单信息')}</div>
            <div className="step cur">{t('提交订单')}</div>
          </div>
        </div>

        <div className="paramSelect">
          <div className="h1"/>
        </div>

        <div className="resultShow">
          <div className="resultBody">
            <img className="img" src={checkPic} alt=""/>
            <div className="t1">{t('恭喜！您的订单已提交！')}</div>
            <div className="t2">{t('您的订单号为：')}<span>{store.orderId}</span></div>

            <div className="t3">
              {t('您的订单已经收到，请注意查收您的邮箱。')}<br/>
              {t('我们将立即处理您的订单以锁定国内现货。')}


            </div>
          </div>
          <div className="resultFoot">
            <Button type="primary" size="large" onClick={() => {
              history.push('/user/quote')
            }}>{t('返回我的报价单')}</Button>
            <Button type="primary" size="large" onClick={() => {
              history.push('/home')
            }}>{t('返回首页')}</Button>
          </div>
        </div>

      </div>

    </React.Fragment>

  )

})
